import { getAccessToken } from './authApi';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/$/, '');

async function videoRequest<T>(action: string, body: Record<string, unknown>): Promise<T> {
  const token = getAccessToken();
  if (!token) throw new Error('Sua sessão NutriSync expirou. Entre novamente.');
  const response = await fetch(`${API_BASE}/video-rooms.php?action=${encodeURIComponent(action)}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    cache: 'no-store',
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result?.success) throw new Error(result?.error || 'Falha na API PHP de vídeo.');
  return result.data as T;
}

export const videoRoomsApi = {
  createDailyRoom: (sessionId: string, nutritionistId: string, patientId: string) =>
    videoRequest<{ roomUrl: string; roomName: string }>('create_daily_room', { sessionId, nutritionistId, patientId }),
  deleteDailyRoom: (roomName: string) =>
    videoRequest<{ deleted: boolean }>('delete_daily_room', { roomName }),
  createMuxStream: (streamId: string, hostId: string, title: string, description?: string) =>
    videoRequest<{ streamId: string; streamKey: string; playbackId: string; rtmpUrl: string }>(
      'create_mux_stream', { streamId, hostId, title, description },
    ),
  endMuxStream: (streamId: string) =>
    videoRequest<{ ended: boolean }>('end_mux_stream', { streamId }),
};
